import { t } from 'i18next';

import { ErrorResponseErrorItemCodeDongle } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeDongle, string> => ({
  'dongle:already_registered': t('dongle.alreadyRegistered', {
    ns: 'apiErrorCodes',
    defaultValue: 'Dongeln är redan registrerad till ett projekt.',
  }),
  'dongle:id_exists': t('dongle.idExists', {
    ns: 'apiErrorCodes',
    defaultValue: 'Dongeln existerar redan.',
  }),
  'dongle:not_found': t('dongle.notFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Dongeln existerar inte.',
  }),
  'dongle:authentication_failed': t('dongle.authenticationFailed', {
    ns: 'apiErrorCodes',
    defaultValue: 'Det gick inte att autentisera dongeln.',
  }),
  'dongle:not_registered': t('dongle.notRegistered', {
    ns: 'apiErrorCodes',
    defaultValue: 'Dongeln är inte registrerad till ett projekt.',
  }),
  'dongle:not_active': t('dongle.notActive', {
    ns: 'apiErrorCodes',
    defaultValue: 'Dongeln är inte aktiv.',
  }),
});
